// processor types, with abbreviation
export function convertProcessorType(type) {
  if (type === "ms") return "Musculoskeletal";
  if (type === "cv") return "Cardiovascular";
  if (type === "nv") return "Nerve";
}
